import type {
  FileUploadConfig,
  MultipleFileUploadConfig,
} from '@pct-ng/feature-file-upload-native';
import { defaultFileUploadConfig } from '@cappus/shared-common';

export const CATEGORY_NAME_MAX_LENGTH = 20;

export const MiskolcCoordinates: google.maps.LatLngLiteral = {
  lat: 48.1043333,
  lng: 20.7913396,
} as const;

export const mecapCoverImageConfig: FileUploadConfig = {
  ...defaultFileUploadConfig,
  cropConfig: {
    showAspectRatio: false,
    defaultAspectRatio: '4:3',
    showMaintainAspectRatio: false,
    maintainAspectRatioDefaultValue: true,
    showContainWithinAspectRatio: false,
    containWithinAspectRatioDefaultValue: true,
    showRotate: false,
  },
};

export const mecapGalleryImageConfig: MultipleFileUploadConfig = {
  ...defaultFileUploadConfig,
  overwriteNewUpload: false,
  multiple: true,
  multipleUpload: false,
  maxFiles: 4,
  cropConfig: {
    showAspectRatio: false,
    defaultAspectRatio: '4:3',
    showMaintainAspectRatio: false,
    maintainAspectRatioDefaultValue: true,
    showContainWithinAspectRatio: false,
    containWithinAspectRatioDefaultValue: true,
    showRotate: false,
  },
};
